import { useAuth } from '@interhyp/util-authentication';
import { useMemo } from 'react';

export function useLegacyIdentity() {
  const { token } = useAuth();
  return useMemo(() => {
    if (!token) {
      return;
    }
    return {
      userId: token.user_id,
      username: token.preferred_username,
      companyId: token.company_id,
      permissions: token.permissions,
      unitId: token.unit_id_deprecated,
      email: token.email,
      name: token.name,
    };
  }, [token]);
}
